module.exports = __webpack_public_path__ + "static/media/Logo.98db13d1.svg";